import router from './zh/router'
import login from './zh/login'
export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    search: '查询',
    export: '导出',
    print: '打印',
    startTime: '开始时间',
    endTime: '结束时间',
    noData: '暂无数据',
    createSuccess: '创建成功',
    addSuccess: '添加成功',
    editSuccess: '修改成功',
    operateSuccess: '操作成功',
    yes: '是',
    no: '否',
    keywords: '关键字',
    phSelect: '请选择',
    phInput: '请输入',
    headTitle: '利欧光伏水泵远程监控系统'
  },
  home: {
    navigation: '功能导航'
  },
  time: {
    second: '秒',
    minute: '分',
    hour: '时',
    day: '天',
    month: '月',
    year: '年',
    thisWeek: '本周',
    lastWeek: '上周'
  },
  map: {
    labelHidden: '标签显隐'
  },
  controlLog: {
    time: '时间',
    query: '查询',
    export: '导出',
    keyWord: '关键字搜索',
    number: '序号',
    pumpHouseName: '泵房名称',
    deviceName: '设备名称',
    deviceId: '设备ID',
    pageMeasurePoint: '页面测点',
    controlMeasurePoint: '下控测点',
    controlValue: '下控值',
    excuter: '执行人',
    controlTime: '下控时间',
    controlIP: '下控IP',
    controlResult: '操作结果',
    startTime: '开始时间',
    endTime: '结束时间',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastQuarter: '最近一个季度',
    queryNoData: '查询无数据！',
    title: '提示',
    tip: '是否确定导出该数据?',
    yes: '是',
    no: '否',
    cancelExport: '取消导出!'
  },
  pumpStatus: {
    run: 'ออนไลน์',
    offline: 'ออฟไลน์',
    stop: 'ปิดเครื่อง',
    fault: 'ความล้มเหลว',
    online: 'ออนไลน์'
  },
  message: {
    queryNoData: '查询无数据!',
    title: '提示',
    tip: '是否确定导出该数据?',
    printTip: '是否要打印该数据?',
    yes: '是',
    no: '否',
    cancelExport: '取消导出!',
    successExport: '导出成功！',
    noDataExport: '无数据导出！',
    noSelect: '未选择区域/测点!',
    startTime: '开始时间',
    endTime: '结束时间',
    minuTip: '请选择当天时间内！',
    dayTip: '请选择当月时间内！'
  },
  router,
  login
}
